<template>
  <div>
    表示できるステーションはありません。
  </div>
</template>

<script>
export default {
  name: 'CNoStation'
}
</script>
